import React from 'react';
import { Users, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const PassengerSelector = ({ 
  searchData, 
  setSearchData, 
  showPassengers, 
  setShowPassengers, 
  language 
}) => {
  const totalPassengers = searchData.adults + searchData.children + searchData.infants;

  return (
    <div className="relative">
      <label className="block text-sm font-semibold text-gray-700 mb-2">
        <Users className="w-4 h-4 inline mr-1" />
        {language === 'en' ? 'Passengers' : 'Passeggeri'}
      </label>
      <button
        onClick={() => setShowPassengers(!showPassengers)}
        className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-amber-500 focus:outline-none text-gray-800 bg-white text-left flex items-center justify-between"
      >
        <span>
          {totalPassengers} {language === 'en' ? (totalPassengers === 1 ? 'Passenger' : 'Passengers') : (totalPassengers === 1 ? 'Passeggero' : 'Passeggeri')}
        </span>
        <ArrowRight className={`w-4 h-4 transition-transform ${showPassengers ? 'rotate-90' : ''}`} />
      </button>
      
      {showPassengers && (
        <div className="absolute top-full mt-2 left-0 right-0 bg-white rounded-lg shadow-xl border-2 border-gray-200 p-4 z-50">
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium">{language === 'en' ? 'Adults (18+)' : 'Adulti (18+)'}</span>
              <div className="flex items-center space-x-3">
                <button
                  onClick={() => setSearchData({ ...searchData, adults: Math.max(1, searchData.adults - 1) })}
                  className="w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center"
                >
                  -
                </button>
                <span className="w-8 text-center font-semibold">{searchData.adults}</span>
                <button
                  onClick={() => setSearchData({ ...searchData, adults: Math.min(7, searchData.adults + 1) })}
                  className="w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center"
                >
                  +
                </button>
              </div>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium">{language === 'en' ? 'Children (2-17)' : 'Bambini (2-17)'}</span>
              <div className="flex items-center space-x-3">
                <button
                  onClick={() => setSearchData({ ...searchData, children: Math.max(0, searchData.children - 1) })}
                  className="w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center"
                >
                  -
                </button>
                <span className="w-8 text-center font-semibold">{searchData.children}</span>
                <button
                  onClick={() => setSearchData({ ...searchData, children: Math.min(6, searchData.children + 1) })}
                  className="w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center"
                >
                  +
                </button>
              </div>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium">{language === 'en' ? 'Infants (0-1)' : 'Neonati (0-1)'}</span>
              <div className="flex items-center space-x-3">
                <button
                  onClick={() => setSearchData({ ...searchData, infants: Math.max(0, searchData.infants - 1) })}
                  className="w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center"
                >
                  -
                </button>
                <span className="w-8 text-center font-semibold">{searchData.infants}</span>
                <button
                  onClick={() => setSearchData({ ...searchData, infants: Math.min(2, searchData.infants + 1) })}
                  className="w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center"
                >
                  +
                </button>
              </div>
            </div>
            <Button
              onClick={() => setShowPassengers(false)}
              className="w-full bg-amber-500 hover:bg-amber-600 text-black font-semibold mt-2"
            >
              {language === 'en' ? 'Done' : 'Fatto'}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PassengerSelector;
